import {addBLazyContainer, initMainHeader} from '../js/src/header-init';
import {addThirdPartyLoad, initFreshChatScript, onPriceMatchFreshChatClick} from "../js/src/utils";
import {getQuoteFormInit} from "../js/src/get-quote-form";
import {init as shopInit} from "../js/pages/shop-main";
import '../scss/pages/product-config.scss';

initFreshChatScript();
global.priceMatch = onPriceMatchFreshChatClick;

initMainHeader();
addThirdPartyLoad(() => {
    getQuoteFormInit()
    addBLazyContainer('.lazy-container');
});
shopInit();



